module.exports = __webpack_public_path__ + "img/icon-thermal-readings.bcea0ccd.svg";